import { IMetCategory } from 'app/shared/model/met-category.model';
import { Status } from 'app/shared/model/enumerations/status.model';

export interface IMetService {
  id?: number;
  code?: string;
  name?: string;
  nameAr?: string;
  nameEn?: string;
  abreviation?: string;
  status?: Status;
  category?: IMetCategory | null;
}

export const defaultValue: Readonly<IMetService> = {};
